const DEFAULT_EMBED_URL = 'https://diskuze.seznam.cz/v3';
const DEFAULT_API_URL = 'https://diskuze.seznam.cz/graphql';
const DEFAULT_WIDGET_URL = 'https://widget.diskuze.seznam.cz';
const LOCAL_STORAGE_KEY = '_szn_discussion_';

function provideDefaultValue(value, defaultValue) {
	return typeof value === 'undefined' ? defaultValue : value;
}

function getLocalStorageData() {
	try {
		if (!window.localStorage) {
			return {};
		}
	} catch (error) {
		//Local Storage is not accessible!
		return {};
	}

	const data = window.localStorage.getItem(LOCAL_STORAGE_KEY);
	const parsedData = JSON.parse(data) || {};

	if (parsedData.expire) {
		const now = new Date();

		if (now.getTime() > parsedData.expire) {
			window.localStorage.removeItem(LOCAL_STORAGE_KEY);

			return {};
		}

		return parsedData.value;
	}

	return parsedData;
}

export default function createEmbedConfig(values) {
	if (values.embedUrl) {
		values.embedUrl = values.embedUrl.replace(/\/*$/g, '');
	}

	const config = {
		embedUrl: provideDefaultValue(values.embedUrl, DEFAULT_EMBED_URL),
		apiUrl: provideDefaultValue(values.apiUrl, DEFAULT_API_URL),
		widgetUrl: provideDefaultValue(values.widgetUrl, DEFAULT_WIDGET_URL),
		linksInNewTab: provideDefaultValue(values.linksInNewTab, false),
		allowScroll: provideDefaultValue(values.allowScroll, true)
	};

	const masterOverride = getLocalStorageData();

	Object.assign(config, masterOverride);
	Object.freeze(config);

	return config;
}

export function createCommentCountConfig(values = {}) {
	const localStorageData = getLocalStorageData();

	const config = {
		apiUrl: provideDefaultValue(values.apiUrl, DEFAULT_API_URL)
	};

	if (localStorageData.commentCountApiUrl) {
		config.apiUrl = localStorageData.commentCountApiUrl;
	}

	Object.freeze(config);

	return config;
}
